<div class="personal-area-container" [ngClass]="{ 'no-padding': !isNotDetails }">
  @if (isNotDetails) {
    <app-info-box
      [iconOptions]="{ type: 'user', theme: 'outline' }"
      [cssProperties]="{ font_size_title: 24 }"
      title="{{ 'personalArea.personal_area' | translate }}"
      description="{{ 'personalArea.here_you_can' | translate }}"
    ></app-info-box>

    <app-navigation-menu [links]="links" [translationEntryPoint]="'personalArea.'"></app-navigation-menu>
  }

  <router-outlet></router-outlet>
</div>
